import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { signUp } from '../../services/authService';
import '../../App.css';
import languageMap from '../languageMap';
import './SignUp.css';
import { Link } from 'react-router-dom';
import { isValidPhone, isValidEmail, isValidPassword } from './validationHelpers';

export default function SignUp() {
  const history = useHistory();

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [managementType, setManagementType] = useState('');
  const [acceptUpdates, setAcceptUpdates] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [popupType, setPopupType] = useState("error"); // "error" or "success"

  const [fieldErrors, setFieldErrors] = useState({
    username: false,
    email: false,
    phone: false,
    password: false,
    confirmPassword: false,
    managementType: false
  });

  const selectedLanguage = languageMap.config.selectedLanguage || 'en';

  const showPopupMessage = (text, type = "error") => {
    setPopupText(text);
    setPopupType(type);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleSignUp = async (event) => {
    event.preventDefault();
    // showPopupMessage("הרשמה אינה זמינה כעת. אנא נסו שוב בהמשך.");

    const errors = {
      username: false,
      email: false,
      phone: false,
      password: false,
      confirmPassword: false,
      managementType: false
    };

    if (!username.trim()) {
      errors.username = true;
      showPopupMessage("נא להזין שם משתמש");
      setFieldErrors(errors);
      return;
    }

    if (!isValidEmail(email)) {
      errors.email = true;
      showPopupMessage("כתובת אימייל לא תקינה");
      setFieldErrors(errors);
      return;
    }

    if (!isValidPhone(phone)) {
      errors.phone = true;
      showPopupMessage("מספר טלפון לא תקין");
      setFieldErrors(errors);
      return;
    }

    if (!isValidPassword(password)) {
      errors.password = true;
      showPopupMessage("הסיסמה חייבת לכלול לפחות 8 תווים, עם אות וספרה לפחות");
      setFieldErrors(errors);
      return;
    }

    if (password !== confirmPassword) {
      errors.confirmPassword = true;
      showPopupMessage("הסיסמאות אינן תואמות");
      setFieldErrors(errors);
      return;
    }

    if (!managementType) {
      errors.managementType = true;
      showPopupMessage("יש לבחור סוג משתמש");
      setFieldErrors(errors);
      return;
    }

    setFieldErrors(errors); // clear errors

    try {
      const result = await signUp(username, email, phone, password, managementType);
      if (result.success) {
        localStorage.setItem('registeredUsername', username);
        showPopupMessage(languageMap.signUpSuccessMessage[selectedLanguage], "success");
        setTimeout(() => {
          history.push('/sign-in');
        }, 2000);
      } else {
        showPopupMessage(languageMap.signUpFailureMessage[selectedLanguage]);
      }
    } catch (error) {
      console.error('Error signing up:', error);
      showPopupMessage(languageMap.signUpFailureMessage[selectedLanguage]);
    }
  };

  return (
    <div className='sign-up-page blur-top blur-bottom blur-background'>
      <div className="logo-container-sign">
        <Link to="/">
          <img src='/icons/logo.png' alt="Logo" className="logo" />
        </Link>
      </div>

      <div className='sign-up'>
        <div className="sign-up-title">{languageMap.signUpTitle[selectedLanguage]}</div>

        <form id="signUpForm" className="sign-up-form" onSubmit={handleSignUp}>
          <div className="form-group">
            <input
              type="text"
              id="username"
              value={username}
              placeholder={languageMap.signUpNameLabel[selectedLanguage]}
              onChange={(e) => {
                setUsername(e.target.value);
                setFieldErrors(prev => ({ ...prev, username: false }));
              }}
              className={fieldErrors.username ? 'input-error' : ''}
            />
          </div>

          <div className="form-group">
            <input
              type="text"
              id="email"
              value={email}
              placeholder={languageMap.signUpEmailLabel[selectedLanguage]}
              onChange={(e) => {
                setEmail(e.target.value);
                setFieldErrors(prev => ({ ...prev, email: false }));
              }}
              className={fieldErrors.email ? 'input-error' : ''}
            />
          </div>

          <div className="form-group">
            <input
              type="text"
              id="phone"
              value={phone}
              placeholder={languageMap.signUpPhoneLabel[selectedLanguage]}
              onChange={(e) => {
                setPhone(e.target.value);
                setFieldErrors(prev => ({ ...prev, phone: false }));
              }}
              className={fieldErrors.phone ? 'input-error' : ''}
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              id="password"
              value={password}
              placeholder={languageMap.signUpPasswordLabel[selectedLanguage]}
              onChange={(e) => {
                setPassword(e.target.value);
                setFieldErrors(prev => ({ ...prev, password: false }));
              }}
              className={fieldErrors.password ? 'input-error' : ''}
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              placeholder="אימות סיסמה"
              onChange={(e) => {
                setConfirmPassword(e.target.value);
                setFieldErrors(prev => ({ ...prev, confirmPassword: false }));
              }}
              className={fieldErrors.confirmPassword ? 'input-error' : ''}
            />
          </div>

          <div className="form-group">
            <select
              id="managementType"
              value={managementType}
              onChange={(e) => {
                setManagementType(e.target.value);
                setFieldErrors(prev => ({ ...prev, managementType: false }));
              }}
              className={`styled-select ${managementType === '' ? 'placeholder' : ''} ${fieldErrors.managementType ? 'input-error' : ''}`}
            >
              <option value="" disabled hidden>בחר סוג משתמש</option>
              <option value="photographer">{languageMap.photographer?.[selectedLanguage] || 'צלם'}</option>
              <option value="event_manager">{languageMap.eventManager?.[selectedLanguage] || 'בעל אירוע'}</option>
            </select>
          </div>
        </form>

        <div className="form-group checkbox-group">
          <label className="checkbox-group">
            <input
              type="checkbox"
              checked={acceptUpdates}
              onChange={(e) => setAcceptUpdates(e.target.checked)}
            />
            {languageMap.acceptUpdates[selectedLanguage]}
          </label>
        </div>

        <button type="submit" form="signUpForm" className="signup-btn">
          {languageMap.signUpButtonLabel[selectedLanguage]}
        </button>
      </div>

      {showPopup && (
        <div className="popup-overlay">
          <div className={`popup ${popupType === "success" ? "popup-success" : ""}`}>
            <button className="popup-close-btn" onClick={closePopup}>×</button>
            <div className="popup-content">
              <img
                src={popupType === "success" ? "/icons/v.png" : "/icons/x.png"}
                alt="Status Icon"
                className="v-icon"
              />
              <span className="popupText">{popupText}</span>
              <img src="/icons/line_g.png" alt="Divider" className="line-icon" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
